export default "__VITE_ASSET__KMRTa3gV__"